const STOPWORDS = new Set([
        "ainda",
        "anos",
        "apenas",
        "cada",
        "como",
        "com",
        "das",
        "defende",
        "defendem",
        "descrito",
        "descrita",
        "dos",
        "entre",
        "era",
        "esta",
        "este",
        "foi",
        "foram",
        "mais",
        "mas",
        "nos",
        "num",
        "numa",
        "para",
        "pela",
        "pelo",
        "por",
        "que",
        "sao",
        "são",
        "ser",
        "sobre",
        "sua",
        "tambem",
        "também",
        "tem",
        "uma",
        "uso",
]);

const tokenize = (value) => {
        const normalized = String(value || "")
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
        const words = normalized.match(/[0-9a-z-]{3,}/g) || [];
        return new Set(words.filter((word) => !STOPWORDS.has(word) && !/^\d+$/.test(word)));
};

const intersectionSize = (left, right) => {
        let count = 0;
        left.forEach((item) => {
                if (right.has(item)) count += 1;
        });
        return count;
};

export const isTimelineFact = (fact) =>
        fact && typeof fact === "object" && !Array.isArray(fact);

const sourceText = (source) =>
        [source?.title, source?.outlet, source?.url].filter(Boolean).join(" ");

const factText = (fact, sources = []) => {
        const sourceIndex = Number(fact?.source_idx);
        const attachedSource =
                Number.isInteger(sourceIndex) && sourceIndex >= 1 && sourceIndex <= sources.length
                        ? sources[sourceIndex - 1]
                        : null;
        return [
                fact?.date,
                fact?.media_claim,
                fact?.truth,
                attachedSource ? sourceText(attachedSource) : "",
        ]
                .filter(Boolean)
                .join(" ");
};

const factAlignmentScore = (fact, topic = {}) => {
        const sources = topic.sources || [];
        const titleTokens = tokenize(topic.title);
        if (titleTokens.size === 0) return 0;

        const factTokens = tokenize(factText(fact, sources));
        const contextTokens = tokenize(
                [topic.summary, topic.deception_strategy, ...(topic.tags || [])]
                        .filter(Boolean)
                        .join(" ")
        );

        return intersectionSize(titleTokens, factTokens) * 10 + intersectionSize(contextTokens, factTokens);
};

export const alignedTimelineFacts = (facts = [], topic = {}) => {
        if (!Array.isArray(facts) || facts.length < 2 || !facts.every(isTimelineFact)) {
                return facts || [];
        }

        const scored = facts.map((fact, index) => ({
                fact,
                index,
                score: factAlignmentScore(fact, topic),
        }));
        const bestScore = Math.max(...scored.map((item) => item.score));
        if (bestScore <= scored[0].score) return facts;

        return [...scored]
                .sort((left, right) => right.score - left.score || left.index - right.index)
                .map((item) => item.fact);
};

export const resolvedFactSourceIndex = (fact, sources = []) => {
        const rawIndex = Number(fact?.source_idx);
        if (Number.isInteger(rawIndex) && rawIndex >= 1 && rawIndex <= sources.length) {
                return rawIndex;
        }

        const factTokens = tokenize(factText(fact));
        if (factTokens.size === 0 || !Array.isArray(sources) || sources.length === 0) {
                return null;
        }

        let bestIndex = null;
        let bestScore = 0;
        sources.forEach((source, index) => {
                const sourceTokens = tokenize(sourceText(source));
                const score = intersectionSize(factTokens, sourceTokens);
                if (score > bestScore) {
                        bestScore = score;
                        bestIndex = index + 1;
                }
        });

        return bestScore > 0 ? bestIndex : null;
};

export const displayTitleForTopic = (topic = {}) => topic.title || "";
